import React, { useCallback } from 'react';
import styles from './select.module.css';
import { IOptionProps } from './Select.types';
import cls from 'clsx';

const Option: React.FC<IOptionProps> = ({
  value,
  onClick,
  selected,
  disabled = false,
  children,
  className
}) => {
  const handleClick = useCallback(() => {
    if (onClick && !disabled) {
      onClick(value);
    }
  }, [value, disabled, onClick]);
  return (
    <div
      className={cls(styles.menuItem, className)}
      onClick={handleClick}
      role="option"
      aria-selected={selected}
    >
      {children}
    </div>
  );
};

export default Option;
